import { render, staticRenderFns } from "./ClientSettingsForm.vue?vue&type=template&id=a09cfa7a"
import script from "./ClientSettingsForm.vue?vue&type=script&lang=ts"
export * from "./ClientSettingsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports